import { NgModule } from '@angular/core';

import { DashboardCardSummaryComponent } from './dashboard-card-summary.component';
import { MiniChartComponent } from './mini-chart/mini-chart.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CommonModule } from '@angular/common';
import { SmallInfoBoxModule } from '../small-info-box/small-info-box.module';
import { FakeSeriesIfEmptyPipe } from './pipes/fake-series-if-empty.pipe';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyModule } from '../../currency/currency.module';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    NgApexchartsModule,
    CommonModule,
    SmallInfoBoxModule,
    NgbDropdownModule,
    CurrencyModule
  ],
  exports: [DashboardCardSummaryComponent],
  declarations: [
    DashboardCardSummaryComponent,
    MiniChartComponent,
    FakeSeriesIfEmptyPipe,
  ],
  providers: [],
})
export class DasboardCardSummaryModule { }
